/* eslint-disable no-unused-expressions */
import "./style.css";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchBranchData } from "../../redux/slices/branchSlice";
import {
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  initState,
  initCommonState,
} from "../../redux/slices/commonSlice";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useState, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";

import MarkerMap from "../../components/Map/MarkerMap";
import Map from "../../components/Map/Map";
import RoadMap from "../../components/Map/RoadMap";
import {
  getEmpLocationAllPath,
  getTrackingEmployeesPath,
  getEmployeeLatAndLongPath,
} from "../../services/config";

import { geolocationStatus } from "../../services/commonServices";

const Index = () => {
  const mapStatus = geolocationStatus();
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;

  const dispatch = useDispatch();
  const branchState = useSelector((state) => state.branch);
  const commonState = useSelector((state) => state.common);

  const [allUsers, setAllUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [isAllUsers, setIsAllUsers] = useState(true);
  const [center, setCenter] = useState({});
  const [isEmptyMap, setIsEmptyMap] = useState(false);
  const [isMapOnly, setIsMapOnly] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(10);

  const getAllUser = useCallback(() => {
    const path = `${getEmpLocationAllPath}${user.user_id}`;
    dispatch(commonGetDataOne(path));
  }, []);

  useEffect(() => {
    getAllUser();
  }, []);

  useEffect(() => {
    if (commonState.commonGetOneSuccess) {
      if (
        Array.isArray(commonState.commonGetOneData) &&
        commonState.commonGetOneData.length
      ) {
        setIsAllUsers(true);
        let center = {
          lat: parseFloat(commonState.commonGetOneData[0].latitude),
          lng: parseFloat(commonState.commonGetOneData[0].longitude),
        };

        const updatedMarkers = commonState.commonGetOneData.map(
          (marker, i) => ({
            id: i,
            lat: parseFloat(marker.latitude),
            lng: parseFloat(marker.longitude),
            name: marker.staffName,
            employeeId: marker.employeeId,
            staffImage: marker.staffImage,
          })
        );

        setAllUsers(updatedMarkers);

        setCenter(center);
      } else {
        let center = {
          lat: 12.985908334627606,
          lng: 77.58141163898391,
        };
        setCenter(center);
      }
    }
    if (commonState.commonGetOneError) {
      setIsAllUsers(false);
      setIsEmptyMap(true);
      setIsMapOnly(true);
      setBranchLat(12.985908334627606);
      setBranchLng(77.58141163898391);
      let center = {
        lat: 12.985908334627606,
        lng: 77.58141163898391,
      };
      setCenter(center);
    }
  }, [commonState, dispatch]);

  const fetchData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranches(branchState.brnGetData);
    }
  }, [branchState.brnGetSuccess]);

  const [state, setState] = useState({
    branchId: "",
    departmentId: 0,
    staffId: "",
    date: "",
  });

  const currentDate = new Date();
  const date = currentDate.getDate().toString().padStart(2, "0");
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const year = currentDate.getFullYear();
  const mainDate = `${year}-${month}-${date}`;

  useEffect(() => {
    setState((prevState) => ({ ...prevState, date: mainDate }));
  }, []);

  const [radius, setRadius] = useState(null);
  const [branchLat, setBranchLat] = useState(null);
  const [branchLng, setBranchLng] = useState(null);
  const [branchName, setBranchName] = useState(null);
  const [destination, setDestination] = useState({});
  const [waypoints, setWaypoints] = useState([]);

  const handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    if (value == "") return;
    setState({ ...state, [name]: value });
  };

  const fetchEmployeeData = useCallback((branchId) => {
    const staffPath = getTrackingEmployeesPath(user?.user_id, branchId);
    dispatch(commonGetData(staffPath));
  }, []);

  useEffect(() => {
    if (commonState.commonGetSuccess) {
      setStaffList(commonState.commonGetData);
      dispatch(initState());
      dispatch(initCommonState());
    }
  }, [commonState.commonGetSuccess]);

  const handleBranchChange = (event) => {
    setState({ ...state, branchId: "", staffId: "" });
    setBranchLat(null);
    setBranchLng(null);
    setBranchName();
    setCenter({});
    setDestination({});
    setWaypoints([]);
    setRadius(null);
    setStaffList([]);

    if (event.target.value == "")
      return toast.error("Please select a valid branch");
    const selectedValue = JSON.parse(event.target.value);
    setState({ ...state, branchId: selectedValue.branchId, staffId: "" });
    setBranchLat(selectedValue.latitude);
    setBranchLng(selectedValue.longitude);
    setBranchName(selectedValue.branch_name);
    setCenter({});
    setDestination({});
    setWaypoints([]);
    setRadius(selectedValue.radius);
    fetchEmployeeData(selectedValue.branchId);
  };

  const handleStaffSubmit = (event) => {
    setCenter({});
    setDestination({});
    const {
      target: { value },
    } = event;
    setState({
      ...state,
      staffId: value,
    });
    if (value == "") return toast.error(`Please select a valid employee`);
    if (state.branchId && state.date) {
      const url = getEmployeeLatAndLongPath(value, state.branchId, state.date);

      dispatch(commonGetDataTwo(url));
    }
  };
  const handleDateSubmit = (event) => {
    setCenter({});
    setDestination({});
    const {
      target: { name, value },
    } = event;
    setState({
      ...state,
      date: value,
    });
    if (value == "" || state.branchId == "" || state.staffId == "")
      return toast.error(`Please select a valid employee`);
    if (state.branchId && state.staffId) {
      const url = getEmployeeLatAndLongPath(
        state.staffId,
        state.branchId,
        value
      );

      dispatch(commonGetDataTwo(url));
    }
  };

  useEffect(() => {
    if (commonState.commonGetTwoSuccess) {
      setWaypoints([]);
      setCenter({});
      setDestination({});
      setIsMapOnly(false);

      if (commonState.commonGetTwoData.length < 1) {
        toast.error("Data not found with given details");
        setIsEmptyMap(true);
      } else if (
        Array.isArray(commonState.commonGetTwoData) &&
        commonState.commonGetTwoData.length > 0
      ) {
        setIsEmptyMap(false);
        setIsAllUsers(false);
        const routeCoord = commonState.commonGetTwoData.map((row) => {
          return {
            location: {
              lat: parseFloat(row.latitude),
              lng: parseFloat(row.longitude),
            },
            stopover: true,
          };
        });

        const newWaypoint = routeCoord.filter((v, index) => {
          return index != 0 && routeCoord.length - 1 != index;
        });

        setWaypoints(newWaypoint);
        setCenter({
          ...center,
          lat: routeCoord[0].location.lat,
          lng: routeCoord[0].location.lng,
        });
        setDestination({
          ...destination,
          lat: routeCoord[routeCoord.length - 1].location.lat,
          lng: routeCoord[routeCoord.length - 1].location.lng,
        });
      } else {
        let center = {
          lat: 12.985908334627606,
          lng: 77.58141163898391,
        };

        setCenter(center);
      }
      dispatch(initState());
      dispatch(initCommonState());
    }

    if (commonState.commonGetTwoError) {
      setIsEmptyMap(true);
      setIsMapOnly(false);
    }
  }, [commonState, dispatch]);

  const [searchValue, setSearchValue] = useState("");
  const handleSearchValue = ({ target: { name, value } }) => {
    setSearchValue(value);
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div className="page-top-bar">
        <span className="color-white">Live Location</span>
        <Form
          className="d-flex align-items-center justify-content-end gap-2"
          style={{ paddingLeft: "150px" }}
        >
          <Form.Control
            name="searchValue"
            placeholder="Search by Employee name & ID"
            value={searchValue}
            onChange={handleSearchValue}
            className="universal-input-search"
            style={{ width: "260px" }}
          />

          <Form.Select
            id="mapdropdown"
            name="branchId"
            onChange={(e) => {
              handleBranchChange(e);
            }}
            className="universal-input"
            style={{ width: "200px" }}
          >
            <option value="" className="color-gray">
              Select Branch
            </option>
            {branches?.map((v, i) => {
              return (
                <option value={JSON.stringify(v)} key={i}>
                  {v.branch_name}
                </option>
              );
            })}
          </Form.Select>
          <Form.Select
            id="mapdropdown"
            name="staffId"
            onChange={(e) => {
              handleChange(e);
              handleStaffSubmit(e);
            }}
            className="universal-input"
            style={{ width: "200px" }}
          >
            {Array.isArray(staffList) && staffList.length > 0 ? (
              <>
                <option value="">Select Employees</option>
                {staffList.map((v, i) => {
                  return (
                    <option value={v.staffId} key={i}>
                      {v.fullName}
                    </option>
                  );
                })}{" "}
              </>
            ) : (
              <option value="">Select Employees</option>
            )}
          </Form.Select>
          {state.branchId && state.staffId && (
            <Form.Control
              id="mapdropdown"
              name="date"
              type="date"
              value={state.date}
              onChange={(e) => {
                handleChange(e);
                handleDateSubmit(e);
              }}
              className="universal-input"
              style={{ width: "200px" }}
            />
          )}
        </Form>
      </div>
      <div className="page-content">
        {isAllUsers && !isEmptyMap && (
          <MarkerMap
            centerPoint={center}
            markers={allUsers}
            zoom={zoomLevel}
            searchValue={searchValue}
          />
        )}
        {!isAllUsers && center != undefined && !isEmptyMap && (
          <RoadMap
            center={center}
            origin={center}
            destination={destination}
            waypoints={waypoints}
            radius={radius}
            branchLat={branchLat}
            branchLng={branchLng}
            branchName={branchName}
          />
        )}
        {isEmptyMap && (
          <Map
            center={center}
            radius={radius}
            lat={branchLat}
            lng={branchLng}
            name={branchName}
            isMapOnly={isMapOnly}
          />
        )}
      </div>
    </>
  );
};

export default Index;
